import objectUtil from '../../../static/js/objectUtil'

// 判断是否是 Function
function isFunction(obj) {
  return Object.prototype.toString.call(obj) === '[object Function]'
}

/**
 * 扫码组件 Core 库
 *
 * @description 设计模式：策略和链式
 * @example const scan = newCore(this, new StrategyByxxx())
 *
 * @param {vue} vue Vue 的实例
 * @param {*} strategy 策略
 *
 */
function Core(vue, strategy) {
  this.$vm = vue
  this.strategy = strategy
  this.initalData = {} // 层层传递的值，以 {...} 的形式传递
}

export default Core

function handlerFnCallback(data, fnCallback) {
  if (isFunction(fnCallback)) fnCallback(data)
}

// ----------------------------- 处理函数（可链式调用） Start --------------------------------- //
/**
 * 获取扫码解析后返回的结果，最终得到扫码后的 scanResult 的值
 * scanResult 的数据结构：{ success: false, origin: null, codeType: null, data: new Map() }
 *
 */
Core.prototype.parse = function () {
  const parse = this.strategy?.parse // 传入的策略上的 start 方法

  if (parse) {
    parse.call(this, this.initalData)
  } else {
    this.$vm.getScanResult()
  }

  return this
}

/**
 * 判断扫码模式
 *
 * 返回判断后的结果，并赋值给下一个链式方法的回调函数的参数
 * 结果数据格式：{ isMa, isHibc, isGS1, isHw }
 */
Core.prototype.type = function (fnCallback) {
  objectUtil.setValueByPath(this.initalData, 'type', this.$vm.getScanType())

  handlerFnCallback(this.initalData, fnCallback)
  return this
}

/**
 * 执行步骤动作
 *
 * 执行后，确定当前步骤是哪一步
 */
Core.prototype.skip = function (fnCallback) {
  this.$vm.skip()

  handlerFnCallback(this.initalData, fnCallback)
  return this
}
// ----------------------------- 处理函数 End --------------------------------- //

// ----------------------------- 异步处理函数（不可链式调用） Start --------------------------------- //
/**
 * 执行扫码逻辑（主体）
 *
 */
Core.prototype.start = async function () {
  const start = this.strategy?.start // 传入的策略上的 start 方法

  if (start) {
    await start.call(this, this.initalData)
  } else {
    await this.$vm.handlerStart(this.initalData)
  }
}
/**
 * 最终步骤
 *
 * 始终会执行的步骤，适用于进行日期的反算，货位数据的请求等，必须放在最后
 */
Core.prototype.finally = async function () {
  const _finally = this.strategy?.finally // 传入的策略上的 finally 方法

  if (_finally) {
    await _finally.call(this, this.initalData)
  } else {
    await this.$vm.handlerFinally(this.initalData)
  }
}
// ----------------------------- 异步处理函数 End --------------------------------- //
